import { headingVariants as headingVariants$1 } from './heading.variants.esm.js';
import { textVariants as textVariants$1 } from './text.variants.esm.js';

var textVariants = Object.keys(textVariants$1);
var headingVariants = Object.keys(headingVariants$1);

// hide leading, tracking, weight from story to encourage the use of the pre-defined text variant base
// design system (i.e. figma) typography definitions

export { headingVariants, textVariants };
//# sourceMappingURL=types.esm.js.map
